const constants = {
  //BACKEND_URL: "http://localhost:8083",
  BACKEND_URL: "https://api.medicta.ch",
};

export default constants;
